import React from "react";
import AllEmissionsPage from "@/pages/emissions";
import { PagedItems } from "@/types/contenu";
import { Emission } from "@/types/emissions";
import { GetServerSideProps } from "next";

type AllEmissionsProps = {
    data: PagedItems<Emission>;
};

const AllEmissions = ({ data }: AllEmissionsProps) => <AllEmissionsPage emissions={data} />;

export const getServerSideProps = (async () => {
    const api = process.env.SERVER_API_URL;

    const response = await fetch(`${api}/v1/emissions`);

    const json: PagedItems<Emission> = await response.json();
    return {
        props: {
            data: json,
        },
    };
}) satisfies GetServerSideProps;

export default AllEmissions;
